export function RoutineVideoSkeleton({ className = "" }: { className?: string }) {
  return (
    <div role="status" aria-label="Loading complete routine" className={`relative aspect-video w-full overflow-hidden bg-[#f4f2f4] ${className}`}>
      <div aria-hidden="true" className="absolute inset-0 animate-[app-skeleton-pulse_1.8s_ease-in-out_infinite] bg-[linear-gradient(180deg,#f4f2f4_0%,#e7e2e6_100%)]">
        <div className="absolute left-1/2 top-1/2 h-10 w-16 -translate-x-1/2 -translate-y-1/2 rounded-lg bg-white/60" />
        <div className="absolute inset-x-3 bottom-3 h-8 rounded-lg bg-white/60" />
      </div>
      <span className="sr-only">Loading complete routine…</span>
    </div>
  );
}
